import { useTranslation } from 'react-i18next';

export default function CTA() {
  const { t } = useTranslation('common');

  return (
    <section id="download" className="grid grid-cols-1 md:grid-cols-2 min-h-screen">
      <div className="relative bg-gradient-to-br from-orange-100 to-pink-100 dark:from-orange-900/20 dark:to-pink-900/20 p-12 flex items-center justify-center">
        
        <div className="relative w-full h-full">
          <img 
            src="https://public.readdy.ai/ai/img_res/6604ff4730e4747b890043919b5f7611.jpg"
            alt="Download UmiGo"
            className="w-full h-full object-cover object-top rounded-3xl"
          />
          
          <div className="absolute bottom-8 left-8 right-8">
            <h2 className="font-black text-white leading-tight">
              <div className="text-7xl mb-1">{t('cta.imageTitle1')}</div>
              <div className="text-6xl mb-1">{t('cta.imageTitle2')}</div>
              <div className="text-5xl">{t('cta.imageTitle3')}</div>
            </h2>
          </div>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-900 p-12 flex items-center justify-center">
        <div className="max-w-lg text-center">
          <h2 className="text-5xl font-black text-gray-900 dark:text-gray-100 mb-8 leading-tight">
            {t('cta.title')}<br />{t('cta.titleLine2')}
          </h2>
          
          <p className="text-lg text-gray-600 dark:text-gray-400 leading-relaxed mb-12 max-w-md mx-auto">
            {t('cta.description')}
          </p>

          <a 
            href="https://umigo.cc/umigo_v1.0.1.apk"
            download
            className="px-16 py-5 bg-gradient-to-r from-purple-600 to-blue-900 text-white rounded-full font-bold text-xl hover:shadow-2xl transition-all inline-flex items-center gap-3 whitespace-nowrap mb-8 cursor-pointer"
          >
            <i className="ri-download-2-line text-2xl"></i>
            {t('cta.downloadButton')}
          </a>

          <div className="flex gap-4 justify-center">
            <img 
              src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
              alt="Get it on Google Play"
              className="h-12 cursor-pointer hover:opacity-80 transition-opacity"
            />
            <img 
              src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
              alt="Download on App Store"
              className="h-12 cursor-pointer hover:opacity-80 transition-opacity"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
